import { LoginPageModule } from './pages/login/login.module';
/*
  Authors : initappz (Rahul Jograna)
  Website : https://initappz.com/
  App Name : CarDekho App Template
  This App Template Source code is licensed as per the
  terms found in the Website https://initappz.com/license
  Copyright and Good Faith Purchasers © 2021-present initappz.
*/
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'welcome',
    loadChildren: () => import('./pages/welcome/welcome.module').then(m => m.WelcomePageModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule)
  },
  {
    path: 'news',
    loadChildren: () => import('./pages/news/news.module').then(m => m.NewsPageModule)
  },
  {
    path: 'city-list',
    loadChildren: () => import('./pages/city-list/city-list.module').then(m => m.CityListPageModule)
  },
  {
    path: 'new-cars',
    loadChildren: () => import('./pages/new-cars/new-cars.module').then(m => m.NewCarsPageModule)
  },
  {
    path: 'used-cars',
    loadChildren: () => import('./pages/used-cars/used-cars.module').then(m => m.UsedCarsPageModule)
  },
  {
    path: 'explore',
    loadChildren: () => import('./pages/explore/explore.module').then(m => m.ExplorePageModule)
  },
  {
    path: 'new-car-details',
    loadChildren: () => import('./pages/new-car-details/new-car-details.module').then(m => m.NewCarDetailsPageModule)
  },
  {
    path: 'used-car-details',
    loadChildren: () => import('./pages/used-car-details/used-car-details.module').then(m => m.UsedCarDetailsPageModule)
  },
  {
    path: 'settings',
    loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsPageModule)
  },
  {
    path: 'suggested',
    loadChildren: () => import('./pages/suggested/suggested.module').then(m => m.SuggestedPageModule)
  },
  {
    path: 'feel-car',
    loadChildren: () => import('./pages/feel-car/feel-car.module').then(m => m.FeelCarPageModule)
  },
  {
    path: 'offers-discount',
    loadChildren: () => import('./pages/offers-discount/offers-discount.module').then(m => m.OffersDiscountPageModule)
  },
  {
    path: 'brand-service-center',
    loadChildren: () => import('./pages/brand-service-center/brand-service-center.module').then(m => m.BrandServiceCenterPageModule)
  },
  {
    path: 'service-center-list',
    loadChildren: () => import('./pages/service-center-list/service-center-list.module').then(m => m.ServiceCenterListPageModule)
  },
  {
    path: 'brand-dealer',
    loadChildren: () => import('./pages/brand-dealer/brand-dealer.module').then(m => m.BrandDealerPageModule)
  },
  {
    path: 'dealer-list',
    loadChildren: () => import('./pages/dealer-list/dealer-list.module').then(m => m.DealerListPageModule)
  },
  {
    path: 'brand-modal-list',
    loadChildren: () => import('./pages/brand-modal-list/brand-modal-list.module').then(m => m.BrandModalListPageModule)
  },
  {
    path: 'spare-part-detail',
    loadChildren: () => import('./pages/spare-part-detail/spare-part-detail.module').then(m => m.SparePartDetailPageModule)
  },
  {
    path: 'service-cost-detail',
    loadChildren: () => import('./pages/service-cost-detail/service-cost-detail.module').then(m => m.ServiceCostDetailPageModule)
  },
  {
    path: 'used-car-dealers',
    loadChildren: () => import('./pages/used-car-dealers/used-car-dealers.module').then(m => m.UsedCarDealersPageModule)
  },
  {
    path: 'car-valuation',
    loadChildren: () => import('./pages/car-valuation/car-valuation.module').then(m => m.CarValuationPageModule)
  },
  {
    path: 'sell-car',
    loadChildren: () => import('./pages/sell-car/sell-car.module').then(m => m.SellCarPageModule)
  },
  {
    path: 'compare-car',
    loadChildren: () => import('./pages/compare-car/compare-car.module').then(m => m.CompareCarPageModule)
  },
  {
    path: 'test',
    loadChildren: () => import('./pages/test/test.module').then( m => m.TestPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'festival',
    loadChildren: () => import('./pages/festival/festival.module').then( m => m.FestivalPageModule)
  },
  {
    path: 'festivalcollect',
    loadChildren: () => import('./pages/festivalcollect/festivalcollect.module').then( m => m.FestivalcollectPageModule)
  },
  {
    path: 'members',
    loadChildren: () => import('./pages/members/members.module').then( m => m.MembersPageModule)
  },
  {
    path: 'festivalexpense',
    loadChildren: () => import('./pages/festivalexpense/festivalexpense.module').then( m => m.FestivalexpensePageModule)
  },
  {
    path: 'expence',
    loadChildren: () => import('./pages/expence/expence.module').then( m => m.ExpencePageModule)
  },
  {
    path: 'accounts',
    loadChildren: () => import('./pages/accounts/accounts.module').then( m => m.AccountsPageModule)
  },
  {
    path: 'income',
    loadChildren: () => import('./pages/income/income.module').then( m => m.IncomePageModule)
  },
  {
    path: 'visitor',
    loadChildren: () => import('./pages/visitor/visitor.module').then( m => m.VisitorPageModule)
  },
  {
    path: 'visitoradd',
    loadChildren: () => import('./pages/visitoradd/visitoradd.module').then( m => m.VisitoraddPageModule)
  },
  {
    path: 'bills',
    loadChildren: () => import('./pages/bills/bills.module').then( m => m.BillsPageModule)
  },
  {
    path: 'billpay',
    loadChildren: () => import('./pages/billpay/billpay.module').then( m => m.BillpayPageModule)
  },
  {
    path: 'complains',
    loadChildren: () => import('./pages/complains/complains.module').then( m => m.ComplainsPageModule)
  },
  {
    path: 'servicesdirectory',
    loadChildren: () => import('./pages/servicesdirectory/servicesdirectory.module').then( m => m.ServicesdirectoryPageModule)
  },
  {
    path: 'noticeboard',
    loadChildren: () => import('./pages/noticeboard/noticeboard.module').then( m => m.NoticeboardPageModule)
  },
  {
    path: 'passwordchange',
    loadChildren: () => import('./pages/passwordchange/passwordchange.module').then( m => m.PasswordchangePageModule)
  },
  {
    path: 'vehical',
    loadChildren: () => import('./pages/vehical/vehical.module').then( m => m.VehicalPageModule)
  },
  {
    path: 'notification',
    loadChildren: () => import('./pages/notification/notification.module').then( m => m.NotificationPageModule)
  },
  {
    path: 'maintenance',
    loadChildren: () => import('./pages/maintenance/maintenance.module').then( m => m.MaintenancePageModule)
  },
  {
    path: 'houseblocklist',
    loadChildren: () => import('./pages/houseblocklist/houseblocklist.module').then( m => m.HouseblocklistPageModule)
  },
  {
    path: 'appupdate',
    loadChildren: () => import('./pages/appupdate/appupdate.module').then( m => m.AppupdatePageModule)
  },
  {
    path: 'billpay-user',
    loadChildren: () => import('./pages/billpay-user/billpay-user.module').then( m => m.BillpayUserPageModule)
  },
  {
    path: 'payment',
    loadChildren: () => import('./pages/payment/payment.module').then( m => m.PaymentPageModule)
  },
  {
    path: 'committee-dashboard',
    loadChildren: () => import('./pages/committee-dashboard/committee-dashboard.module').then( m => m.CommitteeDashboardPageModule)
  },
  {
    path: 'committee-members',
    loadChildren: () => import('./pages/committee-members/committee-members.module').then( m => m.CommitteeMembersPageModule)
  },
  {
    path: 'add-member',
    loadChildren: () => import('./pages/add-member/add-member.module').then( m => m.AddMemberPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
